"use strict";function unsubscribe$(d){return ddSdk_1.ddSdk.invokeAPI(apiName,d)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.unsubscribe$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.realm.unsubscribe";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"4.7.18"},_a[ddSdk_1.ENV_ENUM.android]={vs:"4.7.18"},_a)),exports.unsubscribe$=unsubscribe$,exports.default=unsubscribe$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/realm/unsubscribe.js
// module id = 988
// module chunks = 106